import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { MatDialog, MatDialogConfig } from '@angular/material';
import { environment } from '../../environments/environment';

import { MatSnackBar } from "@angular/material";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

import { PeliculaService } from '../services/pelicula.service';
import { Pelicula } from '../models/pelicula';
@Component({
  selector: 'app-pelicula-editor',
  templateUrl: './pelicula-editor.component.html',
  styleUrls: ['./pelicula-editor.component.css']
})
export class PeliculaEditorComponent implements OnInit {

  model: Pelicula = new Pelicula();
  modelPrev: Pelicula = new Pelicula();

  imagen_vertical = "./assets/avatar.png";
  imagen_horizontal = "./assets/avatar.png";

  model_id;

  upload: boolean = false;
  selectedFile: File = null;

  upload2: boolean = false;
  selectedFile2: File = null;

  Url = environment.imgUrl;
  loading: boolean = false;


  constructor(private modelService: PeliculaService, public dialog: MatDialog, private dialogRef: MatDialogRef<PeliculaEditorComponent>, @Inject(MAT_DIALOG_DATA) data, private snackBar: MatSnackBar) {
    this.model_id = data.id;


    if (data.id != 0) {
      this.get(data.id);
      this.getPrev(data.id);
    }

  }

  ngOnInit() {

  }

  change(a, b) {
    let equal = true;
    for (let [key, val] of Object.entries(a)) {
      if (key != 'horarios') {
        if (b[key] !== val) {
          equal = false;
        }
        else {
          equal = true;
        }

        if (!equal) { break; }
      }
    }

    return equal;
  }


  close() {
    if (!this.change(this.modelPrev, this.model)) {


      const dialogConfig = new MatDialogConfig();

      dialogConfig.width = '390px';
      dialogConfig.data = {
        texto: 'Existen cambios sin guardar ¿Desea salir?'
      };
      const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(
        data => {
          if (data == true) {
            this.dialogRef.close();
          }
        }
      );
    }
    else {
      this.dialogRef.close();
    }
  }


  save() {
    this.loading = true;
    if (this.imagen_vertical == "./assets/avatar.png" || this.imagen_horizontal == "./assets/avatar.png") {
      this.snackBar.open('Seleccione una Imagen Vertical y una Horizontal', '', {
        duration: 3000,
        panelClass: ['red-snackbar']
      });
      this.loading = false;

    }
    else {

      if (this.model.id == null || this.model.id == 0 || this.model.id == undefined) {

        this.modelService.add(this.model).subscribe(
          val => {
            if (this.upload || this.upload2) {
              this.onUploadFile(val.id);
            }
            else {
              this.loading = false;
              this.snackBar.open('Registro Guardado', '', {
                duration: 2000,
              });
              this.dialogRef.close(val.id);
            }

          },
          error => {
            console.log(<any>error);
            this.snackBar.open('Intente de nuevo, ocurrio un error', '', {
              duration: 3000,
              panelClass: ['red-snackbar']
            });
            this.loading = false;
          });
      }
      else {

        this.modelService.edit(this.model).subscribe(
          val => {
            if (this.upload || this.upload2) {
              this.onUploadFile(val.id);
            }
            else {
              this.loading = false;
              this.snackBar.open('Registro Guardado', '', {
                duration: 2000,
              });

              this.dialogRef.close(val.id);

            }
          },
          error => {
            console.log(<any>error);
            this.snackBar.open('Intente de nuevo, ocurrio un error', '', {
              duration: 3000,
              panelClass: ['red-snackbar']
            });
            this.loading = false;
          });

      }
    }

  }

  get(id) {
    this.modelService.get(id).subscribe(
      val => {
        this.model = val;
        if (this.model.imagen_vertical == null)
          this.imagen_vertical = "./assets/avatar.png";
        else
          this.imagen_vertical = this.Url + this.model.imagen_vertical;

        if (this.model.imagen_horizontal == null)
          this.imagen_horizontal = "./assets/avatar.png";
        else
          this.imagen_horizontal = this.Url + this.model.imagen_horizontal;
      },
      error => {
        console.log(<any>error);
      });

  }
  getPrev(id) {
    this.modelService.get(id).subscribe(
      val => {
        this.modelPrev = val;

      },
      error => {
        console.log(<any>error);
      });

  }

  onFileChange(event) {

    this.selectedFile = <File>event.target.files[0];
    this.upload = true;

    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.imagen_vertical = event.target.result;
    }
    reader.readAsDataURL(event.target.files[0]);
    this.model.imagen_vertical = 'new';

  }

  onFileChange2(event) {

    this.selectedFile2 = <File>event.target.files[0];
    this.upload2 = true;

    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.imagen_horizontal = event.target.result;
    }
    reader.readAsDataURL(event.target.files[0]);
    this.model.imagen_horizontal = 'new';

  }

  onUploadFile(id) {

    if (this.upload) {
      const data = new FormData();
      data.append('imagen', this.selectedFile, this.selectedFile.name);
      this.modelService.changeImageVertical(data, id).subscribe(
        val => {

          if (this.upload2) {
            const data2 = new FormData();
            data2.append('imagen', this.selectedFile2, this.selectedFile2.name);
            this.modelService.changeImageHorizontal(data2, id).subscribe(
              val => {

                this.loading = false;
                this.snackBar.open('Registro Guardado', '', {
                  duration: 2000,
                });

                this.dialogRef.close();
              });
          }
          else {
            this.loading = false;
            this.snackBar.open('Registro Guardado', '', {
              duration: 2000,
            });

            this.dialogRef.close();
          }


        });
    }
    else {
      const data2 = new FormData();
      data2.append('imagen', this.selectedFile2, this.selectedFile2.name);
      this.modelService.changeImageHorizontal(data2, id).subscribe(
        val => {

          this.loading = false;
          this.snackBar.open('Registro Guardado', '', {
            duration: 2000,
          });

          this.dialogRef.close();
        });
    }

  }

  destacado() {
    if (this.model.destacado == true)
      this.model.destacado = false;
    else
      this.model.destacado = true;
  }

  cartelera() {
    if (this.model.cartelera == true)
      this.model.cartelera = false;
    else
      this.model.cartelera = true;
  }
}
